import React, { Component } from "react";
import { Tabs, Tab } from "react-bootstrap";
import StateWise from "./StateWise";
import SectorsWheel from "./SectorsWheel/sectorsWheel";
import SectorResponsive from "./SectorsWheel/sectorResponsive";
import StateResponsive from "../map/stateResponsive";
import SectorWise from "./SectorWise";

class ProjectsBy extends Component {
  render() {
    let { isDesktopView } = this.props;
    return (
      <div className="projects-by-wrapper" id="projects">
        <div className="container">
          <h2 className={isDesktopView ? "" : "project-by-heading"}>
            PMG Monitored Project(s)
          </h2>
          <Tabs defaultActiveKey="state" className="projects-by-tabs">
            <Tab eventKey="state" title="States" className="projects-by-state">
              {isDesktopView ? <StateWise /> : <StateResponsive />}
            </Tab>
            <Tab
              eventKey="sector"
              title="Sectors"
              className="projects-by-sectors"
            >
              <div>{isDesktopView ? <SectorWise /> : <SectorResponsive />}</div>
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default ProjectsBy;
